import { render } from "./GanttChartDockView.vue?vue&type=template&id=d3cdf972&scoped=true&ts=true"
import script from "./GanttChartDockView.vue?vue&type=script&lang=ts"
export * from "./GanttChartDockView.vue?vue&type=script&lang=ts"

import "./GanttChartDockView.vue?vue&type=style&index=0&id=d3cdf972&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3cdf972"]])

export default __exports__